import {
	storeLocatorHoursContentSX,
	storeLocatorHoursSX,
	storeLocatorHoursTitleSX,
} from '@/components/content/StoreLocator/styles/StoreLocatorDetails/storeLocatorHoursStyles';
import { useLocalization } from '@/data/Localization';
import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { FC } from 'react';
import { ScheduleData } from 'shared/custom/types/commonTypes';

export const StoreLocatorHours: FC<{
	scheduleData: ScheduleData[];
}> = ({ scheduleData }) => {
	const localization = useLocalization('StoreLocator');
	let dayOfWeek = moment().day();
	dayOfWeek = (dayOfWeek + 6) % 7;

	return (
		<Box sx={storeLocatorHoursSX}>
			<Typography variant="body1" fontSize={12} sx={storeLocatorHoursTitleSX}>
				{localization.storeDetailsHours.t()}
			</Typography>
			<Grid container>
				{scheduleData.map((schedule: ScheduleData, index) => (
					<Grid item key={index} xs={12} sx={storeLocatorHoursContentSX(index === dayOfWeek)}>
						<Box>{schedule.dayName}</Box>
						<Box>{`${schedule.open} - ${schedule.close}`}</Box>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};
